
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { MaskPipe } from 'ngx-mask';
import { Modal } from 'ngx-modal';
import { environment } from '../../../environments/environment';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { Country } from '../../shared/interface/country.interface';
import { State } from '../../shared/interface/state.interface';
import { UserInfo } from '../../shared/interface/user-info.interface';
import { CacheService } from '../../shared/services/cache.service';
import { CommonService } from '../../shared/services/common.service';
import { MessageService } from '../../shared/services/message.service';
import { CustomValidators } from '../../shared/Utils/custom-validator';
import { Utils } from '../../shared/Utils/utils';
import { IsoCodeThree } from '../common/constants';
import { PaymentConstants } from '../constants/payment.constants';
import { PhoneCodesConstants } from '../constants/phone-codes.constant';
import { EcheckPhoneNumberValidation } from '../directive/echeck-phone-validation';
import { AccountType } from '../enums/echeck-accounttypes.enum';
import { EcheckPortalTypes } from '../enums/echeck-portal-types.enum';
import { NotificationType } from '../enums/notification-types.enum';
import { PaymentMethodTypes } from '../enums/order-source-type';
import { SecType } from '../enums/payment-ach-sectypes.enum';
import { PersonalAch } from '../interface/ach-payment/payment-achrequest.interface';
import { ValidateAchRequest } from '../interface/ach-payment/validate-ach-request.interface';
import { ValidateACHResponse } from '../interface/ach-payment/validate-ach-response.interface';
import { Address } from '../interface/address';
import { AppCountryConfig } from '../interface/app-config';
import { DocumentLibrary } from '../interface/document-library.interface';
import { PersonalCheck } from '../interface/eCheck/payment-echeckrequest.interface';
import { ProfileInformation } from '../interface/profile-info';
import { ACHComponentSettings } from '../models/payments/payment-ach.model';
import { PaymentComponentSettings } from '../models/payments/payment.model';
import { AchService } from '../services/ach.service';
import { CustomerService } from '../services/customer.service';
import { DocumentService } from '../services/document.service';

@Component({
  selector: 'app-payment-echeck',
  templateUrl: '../templates/template1/views/new-payment-echeck.component.html',
  styleUrls: [
    '../templates/template1/themes/default/less/order-promotion-fbo.component.less'
  ]
})


export class NewPaymentEcheckComponent implements OnInit {

  // tslint:disable-next-line:no-input-rename
  @Input('paymentComponentSettings') paymentComponentSettings: PaymentComponentSettings;
  // tslint:disable-next-line:no-input-rename
  @Input('fboProfileDetail') fboProfileDetail: ProfileInformation;
  // tslint:disable-next-line:no-input-rename
  @Input('editEcheckInfo') editEcheckInfo: any;
  // tslint:disable-next-line:no-input-rename
  @Input('achPaymentPopup') achPaymentPopup: any;
  @Output() closeAchPaymentPopup = new EventEmitter<any>();
  @ViewChild('paymentFormBtn') paymentFormBtn: ElementRef;
  @ViewChild('saveAchFormBtn') saveAchFormBtn: ElementRef;
  eCheckComponentSettings: ACHComponentSettings = new ACHComponentSettings();
  momentConstructor: (value?: any) => moment.Moment = (<any>moment).default || moment;

  addNewEcheck = true;
  paymentEcheckForm: FormGroup;
  countryCode: string;
  billingAddressInfo: any;
  memberId: number;
  accountTypes: Array<string>;
  eCheckRequest: PersonalAch;
  IsoCountryCode = IsoCodeThree;
  eCheckValidationMessages: Array<String>;
  appConfig: AppCountryConfig;
  countries: any[] = [];
  billingSchemaUrl: string;
  countryId: number;
  memberInfo: any;
  states: any[] = [];
  address: any;
  type: string;
  state: any;
  country: any;
  userInfo: UserInfo;
  storeId: number;
  personalCheckId: string;
  responseObj: any;
  fboProfileInfo: any;
  paymentAuthorizationTAndC?: DocumentLibrary[];
  agreementCheck: boolean;
  isBillingAddressSubmitted: boolean;
  newBillingAddressInfo: any;
  phoneNumberFormat: string;
  showSaveEcheckBtn: boolean;
  echeckRequest: PersonalCheck;
  savedEChecks: any;
  billingAddressObj: any;
  storeInfo:any;
  echeckMemberDetails:any;
  isShowAddress:boolean=false;
  constructor(
    private _achService: AchService,
    private _formbuilder: FormBuilder,
    private _commonService: CommonService,
    private _maskPipe: MaskPipe, private _customerService: CustomerService,
    private _translatePipe: TranslateService, private _documentService: DocumentService,
    private _appMessageService: MessageService,
    private _cacheService: CacheService) { }

  ngOnInit() {
    this.fboProfileInfo = Object.assign({}, this.fboProfileDetail);
    if (this.fboProfileInfo && this.fboProfileInfo.storeEligibility) {
      const storeEligibleCountries = this.fboProfileInfo.storeEligibility;
      const country = storeEligibleCountries.split(',').find(item => item.trim() === "United States").trim();
      if (country) {
        this.countryCode = this.fboProfileInfo.memberAllowedCountries.find(item1 => item1.countryName === country).isoCodeThree;
      }
    }
    this.getCountriesLookup();
    this.getStoreInfo();
    if (this.countryCode) {
      this.constructSchemaFormUrl(this.countryCode);
    }
    this.eCheckComponentSettings.secTypes = [];
    this.eCheckComponentSettings.accountTypes = [AccountType.Checking];
    this.phoneNumberFormat = this._commonService.getPhoneNumberFormatByCountryCode(this.countryCode);
    this.buildEcheckForm();
    if (this.editEcheckInfo ) {
      this.getSavedEcheck();
    }
    else{
      this.isShowAddress=true;
    }
    // this.fetchPaymentAuthorizationTermsConditionDocument();
  }

  /**
   * buildEcheckForm
  */
  buildEcheckForm() {
    let phone = '';
    let email = '';
    if (this.memberInfo) {
      email = this.memberInfo.email;
      if (this.phoneNumberFormat) {
        phone = this._maskPipe.transform(this.memberInfo.phone, this.phoneNumberFormat);
      } else {
        phone = this.memberInfo.phone;
      }

    }
    this.paymentEcheckForm = this._formbuilder.group({
      routerNumber: ['', [Validators.required, Utils.alphaNumericCharacterValidation, Validators.maxLength(9)]],
      accountNumber: ['', [Validators.required, CustomValidators.requiredNotEmpty]],
      dlNumber: ["", [Validators.required, CustomValidators.requiredNotEmpty, CustomValidators.alphaNumericCharacterValidation, CustomValidators.cannotContainSpace]],
      dlState: ["", [Validators.required, CustomValidators.requiredNotEmpty]],
      secType: [''],
      email: [email],
      phone: [phone, [EcheckPhoneNumberValidation.PhoneNumberValidation]],
      //checkNumber: [checkNumber,Validators.required],
      reuse: [true],
      billingAddressId: [''],
      accountType: [""],
      shippingAsBilling: [this.eCheckComponentSettings.billingAddress ? true : false],
    });
  }

  buildEditEcheckForm() {
    let phone = '';
    let email = '';

    //let checkNumber = "";
    if (this.memberInfo) {
      email = this.memberInfo.email;
      if (this.phoneNumberFormat) {
        phone = this._maskPipe.transform(this.memberInfo.phone, this.phoneNumberFormat);
      } else {
        phone = this.memberInfo.phone;
      }

    }
    const accountType=this.eCheckComponentSettings.accountTypes.findIndex(x=>x.toUpperCase() === this.echeckMemberDetails.accountType.toUpperCase());
    this.paymentEcheckForm = this._formbuilder.group({
      routerNumber: [this.echeckMemberDetails.routingNumber, [Validators.required, Utils.alphaNumericCharacterValidation, Validators.maxLength(9)]],
      accountNumber: [this.echeckMemberDetails.accountNumber, [Validators.required, CustomValidators.requiredNotEmpty]],
      dlNumber: [this.echeckMemberDetails.dlNumber, [Validators.required, CustomValidators.requiredNotEmpty, CustomValidators.alphaNumericCharacterValidation, CustomValidators.cannotContainSpace]],
      dlState: [this.echeckMemberDetails.dlState, [Validators.required, CustomValidators.requiredNotEmpty],
        , [Validators.required, CustomValidators.requiredNotEmpty]],
      secType: [this.echeckMemberDetails.secType],
      email: [this.echeckMemberDetails.email],
      phone: [this.echeckMemberDetails.phone, [EcheckPhoneNumberValidation.PhoneNumberValidation]],
      reuse: [this.echeckMemberDetails.reuse],
      billingAddressId: [this.echeckMemberDetails.billingAddressId],
      accountType: [accountType],
      shippingAsBilling: [this.eCheckComponentSettings.billingAddress ? true : false],
    });
  }

  /**
  * @description constructing the schema form url
  * @date 2020-11-21
  * @memberof OrderPromotionComponent
  */
  constructSchemaFormUrl(countryCode: string): void {
    this.billingSchemaUrl = countryCode.toLowerCase() + '-eCheck-billing-schema-form.json?templateVersion='
      + environment.templateVersion;
  }

  /**
   * @description method to get countries lookup
   * @memberof AddressNewComponent
   */
  getCountriesLookup() {
    this._customerService.getCountriesLookup().subscribe((res: Country[]) => {
      if (res && res.length) {
        this.countries = res;
        const country = this.countries.find((x: Country) => x.isocodeThree === (this.countryCode && this.countryCode.toUpperCase()));
        if (country && country.countryId) {
          this.getAllStatesByCountry(country.countryId);
        }
      }
    });
  }
   /*
    get store Info
    */
    getStoreInfo() {
      const countryCodes = [this.countryCode];
      this._customerService.getStoreInfoFromConfig(countryCodes)
          .subscribe(response => {
              if (response) {
                  this.storeId = response.id;
                  this.storeInfo = response;
              }
          });
  }

  /**
   * @description get states by country
   * @memberof AddressNewComponent
   */
  getAllStatesByCountry(countryId: number) {
    this._customerService.getStatesByCountryId(countryId).subscribe((res: State[]) => {
      this.states = res;
    });
  }

  /**
   * @description add mask while changing phone number
   *
   * @memberof NewPaymentEcheckComponent
   */
  onChangeEcheckPhone($event: any) {
    const value = this.paymentEcheckForm.controls["phone"].value;
    let updatedValue = value;
    const alphaNumericValue = value.replace(/[^a-z0-9]/gi, "");
    if (value.match(/[a-zA-Z]/)) {
      if (alphaNumericValue.substr(0, 3).match(/[a-zA-Z]/)) {
        updatedValue = value.replace(/[^a-z0-9]/gi, "");
      } else if (alphaNumericValue.substr(3, 3).match(/[a-zA-Z]/)) {
        updatedValue = this._maskPipe.transform(value, "(000) AAAAAAA");
      } else if (alphaNumericValue.substr(6, 4).match(/[a-zA-Z]/)) {
        updatedValue = this._maskPipe.transform(value, "(000) 000-AAAA");
      }
    } else {
      if (alphaNumericValue.length !== 3) {
        if (this.phoneNumberFormat) {
          updatedValue = this._maskPipe.transform(value, this.phoneNumberFormat);
        } else {
          updatedValue = value;
        }
      }
    }
    this.paymentEcheckForm.controls["phone"].setValue(updatedValue);
  }

  validateNewEcheck() {
    this._appMessageService.setSubmitAddress(true);
    this.eCheckComponentSettings.isAchSubmitted = true;
    let phoneNUmberForrmat = this._commonService.getPhoneNumberFormatByCountryCode(this.countryCode);
    if (this.paymentEcheckForm.valid && this.isBillingAddressSubmitted && this.eCheckComponentSettings.isAchSubmitted) {
      const achFormValue = this._commonService.trimObjectValues(this.paymentEcheckForm.value);
      if (achFormValue.phone) {
        const phoneCode = PhoneCodesConstants.phoneCodes.find(x => achFormValue.phone.toUpperCase().indexOf(x.name) > -1);
        if (phoneCode) {
          achFormValue.phone = achFormValue.phone;
        } else {
          if (phoneNUmberForrmat) {
            achFormValue.phone = this._maskPipe.transform(achFormValue.phone, phoneNUmberForrmat);
          }
          achFormValue.phone = achFormValue.phone;
        }
      }
      const validateAchReq: ValidateAchRequest = {
        accountNumber: achFormValue.accountNumber,
        routingNumber: achFormValue.routerNumber,
        accountType: AccountType.Checking,
        secType: SecType.Tel,
        currency: this.fboProfileInfo.currencyCode,
        dlState: achFormValue.dlState,
        dlNumber: achFormValue.dlNumber,
        checkNumber: 9999,
        firstName: this.newBillingAddressInfo.firstName,
        lastName: this.newBillingAddressInfo.lastName,
        addressOne: this.newBillingAddressInfo.addressLine1,
        addressTwo: this.newBillingAddressInfo.addressLine2,
        city: this.newBillingAddressInfo.city,
        country: this.newBillingAddressInfo.countryCodeTwo,
        state: this.newBillingAddressInfo.stateCode,
        zip: this.newBillingAddressInfo.zip,
        paymentMethodType: PaymentMethodTypes.eCheck,

      };
      this.validateAch(validateAchReq);
    }
    else {
      this.eCheckComponentSettings.isAchSubmitted = false;
    }
  }

  validateAch(validateAchReq: ValidateAchRequest) {
    this.eCheckValidationMessages = [];

    this._achService.validateAch(validateAchReq)
      .subscribe((response: ValidateACHResponse) => {
        if (response && response.success) {
          if ((this.editEcheckInfo && this.editEcheckInfo.id)) {
            this.updateEcheck();
          } else {
            this.savePersonalAch(validateAchReq);
            this.eCheckComponentSettings.achErrorMessage = '';
          }
        } else {
          if (response && !response.success && response.validations.length > 0) {
            this.validations(response.validations);
            const translatedText = this._translatePipe.get('checkout.Please check the below Fields');
            this.eCheckComponentSettings.achErrorMessage = translatedText['value'] + ' <br/>';
            for (let i = 0; i < response.validations.length; i++) {
              this.eCheckComponentSettings.achErrorMessage =
                this.eCheckComponentSettings.achErrorMessage + response.validations[i].message + ', ';
            }
            this.eCheckComponentSettings.achErrorMessage =
              this.eCheckComponentSettings.achErrorMessage.trim()
                .substr(0, this.eCheckComponentSettings.achErrorMessage.length - 2);
          }
        }
      }, error => {
        this.validations(error.validation);
      });
  }

  getUserMemberId() {
    let memberId = null;
    if (this.fboProfileInfo && this.fboProfileInfo.memberId) {
      memberId = this.fboProfileInfo.memberId;
    } else {
      memberId = 0
    }

    return memberId;
  }


  /**
   * save personal achs
   */
  savePersonalAch(achInfo: ValidateAchRequest) {
    const memberId = this.getUserMemberId();
    const eCheckRequest = this.constructSavePersonalEcheckRequest();
    this._achService.savePersonalCheck(memberId, eCheckRequest)
      .subscribe((response: any) => {
        if (response) {
          this.personalCheckId = response;
          const addedNotification: any = this._translatePipe.get('customer-service.Electronic ECheck saved Successfully');
          this._commonService.createNotification('', addedNotification.value, NotificationType.SUCCESS);
          this.responseObj = {
            id: parseInt(atob(response), 10),
            accountNumber: achInfo.accountNumber,
            routingNumber: achInfo.routingNumber,
            accountType: achInfo.accountType,
            secType: achInfo.secType,
            checkNumber: 9999,
            dlNumber: achInfo.dlNumber,
            dlState: achInfo.dlState,
            portalType: EcheckPortalTypes.CustomerCare,
            defaultECheck: false,
            customerId: memberId,
            billingAddress: this.getBillingAddressForAch(),
            billingAddressId: null,
            storeId: this.storeId,
            paymentMethodType: PaymentConstants.echeck,
            billingAddressRequired: true,
            personalCheckId: this.personalCheckId,
            name: this.billingAddressInfo.firstName
          }
          if (this.personalCheckId) {
            this.closeAchPaymentPopup.emit(this.responseObj);
          }
          this.eCheckComponentSettings.isAchSubmitted = false;

          if (this.paymentFormBtn && this.paymentFormBtn.nativeElement) {
            this.paymentFormBtn.nativeElement.focus();
          }
        } else {
          this.eCheckValidationMessages.push('Ach validation failed.');
        }
      }, (error: any) => {
        this.eCheckValidationMessages.push('Ach validation failed.');
      });
  }

  /**
  * map billing address for ach
  */
  getBillingAddressForAch() {
    if (this.newBillingAddressInfo) {
      const billingAddress = {
        id: null,
        addressLine1: this.newBillingAddressInfo.addressLine1,
        addressLine2: this.newBillingAddressInfo.addressLine2 || '',
        addressLine3: this.newBillingAddressInfo.addressLine3 || '',
        addressLine4: this.newBillingAddressInfo.addressLine4 || '',
        countryId: this.newBillingAddressInfo.countryId,
        city: this.newBillingAddressInfo.city,
        state: this.newBillingAddressInfo.stateCode || this.newBillingAddressInfo.state,
        stateCode: this.newBillingAddressInfo.stateCode || this.newBillingAddressInfo.state,
        countryCode: this.newBillingAddressInfo.countryCode,
        countryCodeTwo: this.newBillingAddressInfo.countryCodeTwo,
        zip: this.newBillingAddressInfo.zip,
        phone: '',
        firstName: this.newBillingAddressInfo.firstName,
        lastName: this.newBillingAddressInfo.lastName,
      };
      return billingAddress;
    }
  }
  constructSavePersonalEcheckRequest() {
    let achFormValue = this.paymentEcheckForm.value;
    achFormValue = this._commonService.trimObjectValues(achFormValue);
    if (achFormValue.phone) {
      const phoneCode = PhoneCodesConstants.phoneCodes.find((x) => achFormValue.phone.toUpperCase().indexOf(x.name) > -1);
      if (phoneCode) {
        achFormValue.phone = achFormValue.phone;
      } else {
        if (this.phoneNumberFormat) {
          achFormValue.phone = this._maskPipe.transform(achFormValue.phone, this.phoneNumberFormat);
        } else {
          achFormValue.phone = achFormValue.phone;
        }

      }
    }
    const memberId = this.getUserMemberId();
    this.eCheckRequest = {
      id: this.editEcheckInfo ? this.editEcheckInfo.id : achFormValue.eCheckID,
      accountNumber: achFormValue.accountNumber,
      routingNumber: achFormValue.routerNumber,
      accountType: AccountType.Checking,
      secType: SecType.Tel,
      checkNumber: 9999,
      dlNumber: achFormValue.dlNumber,
      dlState: achFormValue.dlState,
      portalType: EcheckPortalTypes.CustomerCare,
      reusable: achFormValue.reuse,
      defaultECheck: false,
      customerId: memberId,
      billingAddress: this.getBillingAddressForAch(),
      billingAddressId: null,
      storeId: this.storeId ,
      paymentMethodType: PaymentConstants.echeck,
      email: achFormValue.email,
      phone: achFormValue.phone,
      billingAddressRequired: true
    };
    return this.eCheckRequest;

  }

  getNewAddressInfo(address: Address): void {
    if (address) {
      this.billingAddressInfo = this.mapVerifiedAddressToFormFields(address);
      this.isBillingAddressSubmitted = true;
    }
  }

  /**
   * verified Address Mapping
  * @param  {any}  address
  * @returns any
  */
  private mapVerifiedAddressToFormFields(address: any): any {
    if (address) {
      const countryObj = this.getCountryDetailsByCountryIdOrCode(null, address.countryCode);
      const stateObj = this.getStateDetailsByStateIdOrCode(null, address.stateCode);
      const billingAddress = {
        addressLine1: address.addressLine1,
        addressLine2: address.addressLine2,
        city: address.city,
        state: address.stateCode,
        stateId: stateObj.id,
        countryCode: countryObj.countryCode || countryObj.isocodeThree,
        countryId: countryObj.countryId,
        countryCodeTwo: countryObj.isocodeTwo,
        addressVerified: (this.appConfig && this.appConfig.skipAddressVerification) ? true : address.addressVerified,
        zip: address.postalCode,
        firstName: address.firstName,
        lastName: address.lastName,
        phone: address.phone ? address.phone.replace(/[^a-zA-Z0-9]/g, '') : null

      };
      this.newBillingAddressInfo = billingAddress;
      return billingAddress;
    }
  }

  /**
   * Get Country Info by Code or Id
   * @param countryId
   * @param countryCode
   */
  private getCountryDetailsByCountryIdOrCode(countryId: number, countryCode: string): any {
    let countryObj = {};
    if (countryId) {
      countryObj = this.countries.filter((x: any) => x.countryId === countryId)[0];
      let isoCountryCodeTwo = countryObj;
    }
    if (countryCode) {
      countryObj = this.countries.filter((x: any) => x.isocodeThree === countryCode)[0];
    }
    return countryObj;
  }

  /**
   * Get State Info by Code or Id
   * @param stateId
   * @param stateCode
   */
  private getStateDetailsByStateIdOrCode(stateId: number, stateCode: string): any {
    let stateObj = {};
    if (stateId) {
      stateObj = this.states.filter((x: any) => x.id === stateId)[0];
    }
    if (stateCode) {
      stateObj = this.states.filter((x: any) => x.stateCode === stateCode)[0];
    }
    return stateObj;
  }

  /**
   * @description to display errors
   * @date 2020-12-26
   * @param {*} error
   * @memberof NewPaymentEcheckComponent
   */
  validations(error: any) {
    if (error) {
      error.forEach((x: any) => {
        const achErrorNotification: any = this._translatePipe.get('Ach.' + x.message);
      });
    }
  }

  /**
   * @description on click of checkbox (same as shipping address) this method triggers
   *
   * @param {*} event
   * @memberof NewPaymentEcheckComponent
   */
  showBillingAddress(event: any): void {
    const target = event.target;
    if (target.checked) {
      this.useShippingAsBilling(true);
      this.eCheckComponentSettings.viewBillingAddress = false;
      this.paymentEcheckForm.controls["shippingAsBilling"].setValue(true);
    } else {
      this.useShippingAsBilling(false);
      this.eCheckComponentSettings.viewBillingAddress = true;
      this.paymentEcheckForm.controls["shippingAsBilling"].setValue(false);
    }
  }
  /**
    * @description sets shippingAsBilling value
    * @private
    * @param {Address} shippingAddress
    * @param {boolean} useShipping
    * @memberof NewPaymentEcheckComponent
    */
  private useShippingAsBilling(useShipping: boolean): void {
    if (this.eCheckComponentSettings) {
      if (useShipping) {
        this.eCheckComponentSettings.viewBillingAddress = false;
        this.paymentEcheckForm.controls["shippingAsBilling"].setValue(true);
        this.billingAddressInfo = this.getBillingAddressForAch();
      } else {
        this.paymentEcheckForm.controls["shippingAsBilling"].setValue(false);
      }
    } else {
      this.eCheckComponentSettings.viewBillingAddress = false;
    }
  }
  updateEcheck() {
    const eCheckRequest = this.constructSavePersonalEcheckRequest();
    if (this.fboProfileDetail && this.fboProfileDetail.memberId && eCheckRequest) {
      this._achService.updatePersonalEcheck(this.fboProfileDetail.memberId, eCheckRequest)
        .subscribe(response => {
          if (response) {
            const addedNotification: any = this._translatePipe.get('customer-service.Electronic ECheck Updated Successfully.');
            this._commonService.createNotification('', addedNotification.value, NotificationType.SUCCESS);
            this.closeAchPaymentPopup.emit(eCheckRequest);
            this.paymentEcheckForm.reset();

          } else {
            const notification: any = this._translatePipe.get('customer-service.Unable to Update ECehck.');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
          }
        });
    }
  }

  /**
     * Get ECheckS
     */
  getSavedEcheck(): void {
    if (this.fboProfileInfo.memberId) {
      this._achService.getSavedEchecks(this.fboProfileInfo.memberId, this.countryCode, PaymentMethodTypes.eCheck)
        .subscribe((response: any) => {
          if (response && response.length > 0) {
            this.savedEChecks = response;
            const eCheck = this.savedEChecks.find(x => x.id === this.editEcheckInfo.id);
            this.echeckMemberDetails = eCheck;
            this.buildEditEcheckForm();
            this.billingAddressObj = this.prepareBillingAddress(eCheck.billingAddress);
            this.isShowAddress=true;
          }
        });
    }
  }
  prepareBillingAddress(billingAdres: any) {
    let countryObj = null;
    const countries = this._cacheService.get(CacheKey.COUNTRIES);
    if (countries) {
      countryObj = countries.find((x: Country) => x.isocodeTwo === billingAdres.countryCode.toUpperCase());
    }
    const address = {
      addressLine1: billingAdres.addressLine1,
      addressLine2: billingAdres.addressLine2,
      addressLine3: billingAdres.addressLine3,
      addressLine4: billingAdres.addressLine4,
      city: billingAdres.city,
      state: billingAdres.state,
      zip: billingAdres.zip,
      firstName: billingAdres.firstName,
      lastName: billingAdres.lastName,
      countryId: countryObj.countryId || countryObj.id
    };
    return address;
  }

   /**
     * To Close Echeck Popup
     */
    closeEcheckPopup(): void {
      this.paymentEcheckForm = null;
      this.achPaymentPopup.close();
  }

  //   fetchPaymentAuthorizationTermsConditionDocument(): void {
  //     const customerTypeId = (DocumentLibraryMemberId.Distributor || DocumentLibraryMemberId.Preferred_Customer);
  //     const displaySetionId = DisplaySectionId.Payment_Page;
  //     this._documentService.getDocuments(Portal.Csp, customerTypeId, displaySetionId, this.countryCode, this.fboProfileInfo.languageCode)
  //         .subscribe(response => {
  //             if (response && response[0].body) {
  //                 response[0].body = _.orderBy(response[0].body, ['documentUrl'], ['asc']);
  //                 this.paymentAuthorizationTAndC = response[0].body;
  //                 if (this.paymentAuthorizationTAndC && this.paymentAuthorizationTAndC.length) {
  //                     this.paymentAuthorizationTAndC.forEach(item => {
  //                         item.isSelected = false;
  //                     });
  //                 }
  //             } else {
  //                 const notification: any = this._translatePipe.get('order.Unable to fetch Agreement Details');
  //                 this._commonService.createNotification('', notification.value, NotificationType.ERROR);
  //             }
  //         }, (error: any) => {
  //             const notification: any = this._translatePipe.get('order.Unable to fetch Agreement Details');
  //             this._commonService.createNotification('', notification.value, NotificationType.ERROR);
  //         });
  // }
}







// WEBPACK FOOTER //
// ./src/app/customerservice/components/new-payment-echeck.component.ts